<template>
  <div>
    <ul v-if="loaded">
      <li v-for="product in allProducts" :key="product._id">
        <template v-if="cartItems[product._id] > 0">
          <productTile
            :data="product"
            small="true"
            @click="showProduct(product._id)"
          />
          <div>
            <button
              id="buy"
              @click="doAdd(product._id, 1)"
              :disabled="cartItems[product._id] >= 5"
            >
              Add
            </button>
            {{ cartItems[product._id] }}
            <button id="buy" @click="doAdd(product._id, -1)">
              {{ cartItems[product._id] > 1 ? "Remove" : "Delete" }}
            </button>
          </div>
          <div>Rs.{{ cartItems[product._id] * product.price }}/-</div>
        </template>
      </li>
      <div id="proceed">
        <div></div>
        <div style="margin:0px">Total Rs.{{ getTotal() }}/-</div>
      </div>
      <div id="proceed">
        <div></div>
        <div></div>
        <button @click="doBuy">Proceed To Buy</button>
      </div>
    </ul>
  </div>
</template>

<script>
import ProductTile from "../components/Product/ProductTile.vue";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      allProducts: [],
      loaded: false,
    };
  },
  computed: {
    cartItems() {
      return this.$store.state.cart;
    },
  },
  methods: {
    ...mapMutations(["addToCart", "emptyCart"]),
    async getProduct(id) {
      return new Promise((res) => {
        this.axios.get(`product/${id}`).then((response) => {
          res(response.data);
        });
      });
    },
    async getAllProducts() {
      for (const product of Object.keys(this.cartItems)) {
        if (this.cartItems[product] <= 0) {
          continue;
        }
        const prod = await this.getProduct(product);
        this.allProducts.push(prod);
      }
      this.loaded = true;
    },
    doAdd(id, quantity) {
      this.addToCart({ productId: id, quantity });
    },
    getTotal() {
      let total = 0;
      for (const product of this.allProducts) {
        total += product.price * this.cartItems[product._id];
      }
      return total;
    },
    showProduct(id) {
      this.$router.push({ path: "detail", query: { id } });
    },
    async doBuy() {
      confirm("Are you sure to buy?");
      await this.axios.post("order", { products: this.$store.state.cart });
      alert("Purchased...Thankyou!!!");
      this.emptyCart();
      this.$router.push("/");
    },
  },
  mounted() {
    this.getAllProducts();
  },
  components: {
    ProductTile,
  },
};
</script>

<style lang="scss" scoped>
div {
  margin: 30px;
  // padding:30px;
  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    justify-content: space-around;
    li {
      padding: 20px;
      display: flex;
      align-items: center;
    }
  }
}

button {
  // margin: 10px;
  padding: 5px 10px;
  font-weight: normal;
  font-size: 1em;
  letter-spacing: 0.5px;
  border: 1px transparent;
  border-radius: 5px;
  color: #f7f7f7;
  background-color: #2c3e50;
}
#buy {
  margin: 10px;
  font-size: 0.8em;
}
#proceed {
  padding-left: 500px;
  margin: 0px;
}
</style>
